module.exports = __webpack_public_path__ + "cuttingLineSlideAlt.webp?4b225b9323ceb632643538ebafe885e7";